module.exports = function (options)
{

    return {
        ...options,

        // Overwrite options
        // language: 'en',

        // Add styles
        stylesSet: [
            {name: 'Normal', element: 'span', attributes: {'class': ''}},
            {name: 'Primaire knop', element: 'a', attributes: {'class': 'btn-primary'}},
            {name: 'Secundaire knop', element: 'a', attributes: {'class': 'btn-secondary'}},
            {name: 'Tertiaire knop', element: 'a', attributes: {'class': 'btn-tertiary'}},
        ],

        // Allow tags.
        format_tags: 'p;h1;h2;h3;h4;h5',

    };

};
